import { useMemo } from 'react';

import { usePlayerStore } from '../store/playerStore';

export function usePlayerTimeline(playerId?: string) {
  const store = usePlayerStore();
  const resolvedActorId = playerId ?? store.state.activeActorId;
  const activeActor = resolvedActorId ? store.getActor(resolvedActorId) : undefined;
  const { transport } = store.state;

  return useMemo(
    () => ({
      isPlaying: transport.isPlaying,
      currentFrame: transport.currentFrame,
      duration: transport.duration,
      activeActorId: resolvedActorId ?? null,
      activeActor,
    }),
    [activeActor, resolvedActorId, transport.currentFrame, transport.duration, transport.isPlaying],
  );
}
